<template>
  <component
    :is="componentLoader"
    :key="key"
    :width="width"
    :height="height"
    class="v-icon"
    :strokewidth="strokewidth"
    :fill="fill"
    :secondaryfill="secondaryfill"
  >
  </component>
</template>

<script>
export default {
  props: {
    icon: { type: String, default: null },
    width: { type: Number, default: 24 },
    height: { type: Number, default: 24 },
    strokewidth: { type: Number, default: 2 },
    fill: { type: String, default: "grey" },
    secondaryfill: { type: String, default: null },
  },
  data() {
    return {
      key: new Date().getTime(),
    };
  },
  computed: {
    componentLoader() {
      if (this.icon !== null) {
        return () => import(`@/components/icons/${this.icon}`);
      } else {
        return null;
      }
    },
  },
  methods: {
    loadComponent() {
      this.componentLoader().then(() => {});
    },
  },
  mounted() {
    if (this.icon !== null) {
      this.loadComponent();
    }
  },
};
</script>
